// extracted by mini-css-extract-plugin
module.exports = {"viewProfileRequestAction":"LogoutOverlay_viewProfileRequestAction__3AwCu","link":"LogoutOverlay_link__1L99J"};